export interface Anime {
  id: string;
  title: string;
  originalTitle: string;
  category: string;
  kind: string;
  episodes: string;
  status: string;
  rating: string;
  tags: string[];
  highlights: string;
  summary: string;
  image: string;
}

export const categories = ["全部", "治愈系", "日常系", "温馨番剧", "萌系动画"] as const;

export const animes: Anime[] = [
  {
    id: "summer-friend",
    title: "夏目友人帐",
    originalTitle: "夏目友人帳",
    category: "治愈系",
    kind: "TV 动画",
    episodes: "6 季 · 全 74 话",
    status: "已完结",
    rating: "9.6",
    tags: ["妖怪", "温情", "致郁变治愈"],
    highlights: "每一次相遇都是一场温柔的告别",
    summary:
      "能看见妖怪的少年夏目，继承了祖母留下的友人帐。与猫咪老师一路同行，把名字还给妖怪们的同时，也一点点拼回自己遗失的温柔与孤独。是治愈番里绕不开的经典。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20summer%20countryside%20meadow%20at%20golden%20sunset%2C%20a%20gentle%20boy%20walking%20with%20a%20round%20white%20cat%2C%20soft%20green%20fields%20and%20fireflies%2C%20anime%20style%20illustration%2C%20soothing%20pastel%20palette%2C%20calm%20and%20heartwarming%20mood&width=600&height=820&seq=anime-summer-friend&orientation=portrait",
  },
  {
    id: "yuru-camp",
    title: "摇曳露营△",
    originalTitle: "ゆるキャン△",
    category: "日常系",
    kind: "TV 动画",
    episodes: "3 季 + OVA",
    status: "已完结",
    rating: "9.2",
    tags: ["露营", "美食", "治愈日常"],
    highlights: "富士山下的冬日火锅，暖到心底",
    summary:
      "少女们在山野间搭帐篷、煮火锅、看星空的故事。节奏舒缓得像午后阳光，看着她们认真吃一碗热汤面，再烦躁的心情也会慢慢安静下来。",
    image:
      "https://readdy.ai/api/search-image?query=night%20camping%20by%20a%20lake%20under%20starry%20sky%20with%20snowy%20mount%20fuji%20in%20distance%2C%20tent%20and%20small%20campfire%20with%20steaming%20hotpot%2C%20anime%20style%20illustration%2C%20cool%20blue%20night%20with%20warm%20orange%20firelight%2C%20peaceful%20cozy%20mood&width=600&height=820&seq=anime-yuru-camp&orientation=portrait",
  },
  {
    id: "shirokuma-cafe",
    title: "白熊咖啡馆",
    originalTitle: "しろくまカフェ",
    category: "温馨番剧",
    kind: "TV 动画",
    episodes: "全 50 话",
    status: "已完结",
    rating: "9.0",
    tags: ["动物", "搞笑", "治愈"],
    highlights: "客人们全是会说话的动物",
    summary:
      "白熊店长经营着一家咖啡馆，客人们是熊猫、企鹅、羊驼这些会说话的动物们。每集都是轻松的小日常，温柔又有梗，适合吃饭时点开一集。",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20little%20cafe%20with%20a%20friendly%20white%20polar%20bear%20barista%20serving%20coffee%2C%20cute%20panda%20and%20penguin%20customers%2C%20warm%20cream%20and%20orange%20tones%2C%20chibi%20anime%20style%2C%20soft%20heartwarming%20illustration&width=600&height=820&seq=anime-shirokuma-cafe&orientation=portrait",
  },
  {
    id: "tamako-market",
    title: "玉子市场",
    originalTitle: "たまこまーけっと",
    category: "温馨番剧",
    kind: "TV 动画",
    episodes: "全 12 话",
    status: "已完结",
    rating: "8.7",
    tags: ["商店街", "恋爱", "年糕"],
    highlights: "鸟王子降临商店街的奇妙日常",
    summary:
      "商店街年糕店家的女儿玉子，每天都元气满满地生活着。直到一只会说人话的鸟闯进她的生活，一段温暖又欢乐的商店街日常就此展开。",
    image:
      "https://readdy.ai/api/search-image?query=bright%20japanese%20shopping%20street%20with%20colorful%20food%20stalls%2C%20a%20cheerful%20girl%20holding%20rice%20cakes%2C%20a%20cute%20green%20bird%20perched%20nearby%2C%20sunny%20warm%20tones%2C%20kawaii%20anime%20style%2C%20lively%20cozy%20mood&width=600&height=820&seq=anime-tamako&orientation=portrait",
  },
  {
    id: "barakamon",
    title: "元气囝仔",
    originalTitle: "ばらかもん",
    category: "治愈系",
    kind: "TV 动画",
    episodes: "全 12 话",
    status: "已完结",
    rating: "9.1",
    tags: ["书法", "乡村", "成长"],
    highlights: "被岛民们治愈的傲娇书法家",
    summary:
      "在东京受挫的年轻书法家被放逐到五岛列岛，遇上一群热情又吵闹的岛民。在大海、笑声和天真烂漫的小岛日常里，重新找回书法的初心。",
    image:
      "https://readdy.ai/api/search-image?query=small%20seaside%20island%20village%20with%20white%20paper%20lanterns%20and%20ocean%20in%20background%2C%20a%20young%20calligrapher%20sitting%20with%20ink%20brush%20and%20children%20gathered%2C%20bright%20blue%20sky%2C%20warm%20sunny%20anime%20illustration%2C%20lively%20healing%20mood&width=600&height=820&seq=anime-barakamon&orientation=portrait",
  },
  {
    id: "nonnonbiyori",
    title: "悠哉日常大王",
    originalTitle: "のんのんびより",
    category: "日常系",
    kind: "TV 动画",
    episodes: "3 季 + 剧场版",
    status: "已完结",
    rating: "8.8",
    tags: ["乡村", "童年", "慢节奏"],
    highlights: "那句传遍全网的「喵帕斯」",
    summary:
      "五个孩子在偏远乡村学校里的慢生活。春天摘野菜、夏天抓萤火虫、冬天滑雪橇，把日子过成了一首温柔的诗，适合睡前一集。",
    image:
      "https://readdy.ai/api/search-image?query=peaceful%20rural%20japanese%20village%20in%20autumn%2C%20kids%20on%20bicycles%20on%20a%20dirt%20path%20through%20rice%20fields%2C%20golden%20leaves%20and%20warm%20sunlight%2C%20soft%20anime%20style%2C%20nostalgic%20gentle%20mood&width=600&height=820&seq=anime-nonnonbiyori&orientation=portrait",
  },
  {
    id: "k-on",
    title: "轻音少女",
    originalTitle: "けいおん！",
    category: "萌系动画",
    kind: "TV 动画",
    episodes: "2 季 + 剧场版",
    status: "已完结",
    rating: "9.0",
    tags: ["音乐", "社团", "轻松"],
    highlights: "放学后的下午茶与乐队日常",
    summary:
      "五个女孩加入轻音部的故事。练琴的时间没有喝茶吃点心的时间多，但她们在校园里留下的每一帧笑容，都是青春最美好的样子。",
    image:
      "https://readdy.ai/api/search-image?query=five%20high%20school%20girls%20in%20school%20uniforms%20with%20guitars%20and%20afternoon%20tea%20set%20on%20a%20clubroom%20table%2C%20pink%20and%20cream%20soft%20tones%2C%20kawaii%20anime%20style%2C%20cheerful%20light%20mood&width=600&height=820&seq=anime-kon&orientation=portrait",
  },
  {
    id: "hackadoll",
    title: "妖精森林的小不点",
    originalTitle: "ハクメイとミコチ",
    category: "萌系动画",
    kind: "TV 动画",
    episodes: "全 12 话",
    status: "已完结",
    rating: "9.3",
    tags: ["微观世界", "手作", "治愈"],
    highlights: "针尖大小的世界里藏着整片温柔",
    summary:
      "身高只有9厘米的两个小个子女孩，住在森林里。做饭、采药、修理小屋，把微观世界的生活过得认真又精致，每一帧都能当壁纸。",
    image:
      "https://readdy.ai/api/search-image?query=tiny%20girls%20the%20size%20of%20fingers%20in%20a%20lush%20mossy%20forest%20built%20from%20natural%20objects%2C%20cooking%20on%20a%20leaf%20stove%2C%20warm%20green%20and%20brown%20tones%2C%20delicate%20hand%20drawn%20anime%20style%2C%20cozy%20magical%20mood&width=600&height=820&seq=anime-hakumei&orientation=portrait",
  },
  {
    id: "tonari-totoro",
    title: "龙猫",
    originalTitle: "となりのトトロ",
    category: "治愈系",
    kind: "剧场版",
    episodes: "电影 · 86 分钟",
    status: "已完结",
    rating: "9.5",
    tags: ["宫崎骏", "奇幻", "童年"],
    highlights: "那只永远在等你的胖龙猫",
    summary:
      "小月和妹妹搬到乡下，遇见了只有孩子才能看见的森林精灵龙猫。宫崎骏笔下最温柔的童话，适合每一个想回到童年的时刻。",
    image:
      "https://readdy.ai/api/search-image?query=a%20round%20fluffy%20forest%20spirit%20resembling%20a%20huge%20friendly%20cat%20under%20a%20giant%20camphor%20tree%2C%20two%20little%20girls%20in%20summer%20dresses%2C%20warm%20green%20forest%20and%20golden%20light%2C%20studio%20ghibli%20style%2C%20magical%20gentle%20mood&width=600&height=820&seq=anime-totoro&orientation=portrait",
  },
  {
    id: "spirited-away",
    title: "千与千寻",
    originalTitle: "千と千尋の神隠し",
    category: "治愈系",
    kind: "剧场版",
    episodes: "电影 · 125 分钟",
    status: "已完结",
    rating: "9.6",
    tags: ["宫崎骏", "成长", "经典"],
    highlights: "每一段旅程都是一场自我救赎",
    summary:
      "误入神明世界的千寻，为救回变成猪的父母，在汤屋打工成长。从怯懦到勇敢，这是很多人心中永远的治愈与勇气之源。",
    image:
      "https://readdy.ai/api/search-image?query=a%20determined%20girl%20walking%20across%20a%20wooden%20bridge%20toward%20a%20glowing%20red%20bathhouse%20at%20dusk%2C%20lanterns%20and%20floating%20spirits%2C%20warm%20magical%20anime%20style%2C%20stunning%20cinematic%20mood&width=600&height=820&seq=anime-chihiro&orientation=portrait",
  },
  {
    id: "daily-life",
    title: "日常",
    originalTitle: "日常",
    category: "日常系",
    kind: "TV 动画",
    episodes: "全 26 话",
    status: "已完结",
    rating: "8.9",
    tags: ["无厘头", "搞笑", "校园"],
    highlights: "日常本身就是最大的奇观",
    summary:
      "「我们所度过的每个平凡的日常，也许就是连续发生的奇迹。」无厘头到极致的校园喜剧，笑着笑着就被治愈了，是日常系的天花板。",
    image:
      "https://readdy.ai/api/search-image?query=chaotic%20yet%20colorful%20school%20classroom%20with%20a%20robot%20girl%20and%20two%20playful%20schoolgirls%2C%20flying%20chalk%20and%20books%2C%20bright%20pop%20colors%2C%20silly%20fun%20anime%20style%2C%20energetic%20comedy%20mood&width=600&height=820&seq=anime-daily&orientation=portrait",
  },
  {
    id: "lucky-star",
    title: "幸运星",
    originalTitle: "らき☆すた",
    category: "萌系动画",
    kind: "TV 动画",
    episodes: "全 24 话",
    status: "已完结",
    rating: "8.4",
    tags: ["日常", "宅文化", "吐槽"],
    highlights: "贫乳的最终奥义与吐槽日常",
    summary:
      "围绕性格各异的少女们的校园日常，充满了宅向吐槽与梗文化。又碎又可爱，是许多人的童年快乐源泉，越看越上头。",
    image:
      "https://readdy.ai/api/search-image?query=cheerful%20anime%20girls%20in%20school%20uniforms%20chatting%20at%20a%20desk%20with%20snacks%20and%20chocolate%20croissant%2C%20soft%20pink%20and%20cream%20colors%2C%20cute%20chibi%20anime%20style%2C%20playful%20slice%20of%20life%20mood&width=600&height=820&seq=anime-luckystar&orientation=portrait",
  },
];

export interface Collection {
  id: string;
  title: string;
  desc: string;
  count: string;
  mood: string;
  tags: string[];
  image: string;
}

export const collections: Collection[] = [
  {
    id: "cry-and-smile",
    title: "催泪治愈片单",
    desc: "哭着哭着就笑了，那些看完心里暖暖的作品",
    count: "12 部",
    mood: "想大哭一场",
    tags: ["夏目友人帐", "萤火之森", "千与千寻"],
    image:
      "https://readdy.ai/api/search-image?query=soft%20tear%20drop%20shaped%20light%20over%20a%20warm%20starry%20night%20scene%2C%20silhouette%20of%20two%20people%20under%20fireflies%2C%20melancholy%20yet%20heartwarming%2C%20warm%20orange%20and%20deep%20blue%20tone%2C%20emotional%20anime%20illustration&width=900&height=620&seq=col-cry&orientation=landscape",
  },
  {
    id: "food-heal",
    title: "美食治愈片单",
    desc: "没有什么是好好吃一顿解决不了的",
    count: "9 部",
    mood: "深夜看美食",
    tags: ["摇曳露营△", "异世界食堂", "卫宫饭"],
    image:
      "https://readdy.ai/api/search-image?query=steaming%20hot%20japanese%20food%20on%20a%20wooden%20table%20with%20steam%20rising%2C%20warm%20cozy%20lamplight%2C%20appetizing%20anime%20food%20illustration%2C%20golden%20and%20cream%20tones%2C%20comforting%20gourmet%20mood&width=900&height=620&seq=col-food&orientation=landscape",
  },
  {
    id: "country-slow",
    title: "乡村慢生活片单",
    desc: "跟着主角们，把日子过成一首诗",
    count: "8 部",
    mood: "向往田园",
    tags: ["悠哉日常大王", "元气囝仔", "龙猫"],
    image:
      "https://readdy.ai/api/search-image?query=serene%20rural%20village%20with%20rice%20fields%2C%20windmill%20and%20soft%20hills%20under%20warm%20afternoon%20sun%2C%20birds%20and%20flowers%2C%20peaceful%20anime%20background%20art%2C%20green%20and%20cream%20tones%2C%20gentle%20nostalgic%20mood&width=900&height=620&seq=col-country&orientation=landscape",
  },
  {
    id: "pet-warm",
    title: "动物暖心片单",
    desc: "毛茸茸的世界，专治各种不开心",
    count: "10 部",
    mood: "吸动物回血",
    tags: ["白熊咖啡馆", "夏目友人帐", "猫咪日常"],
    image:
      "https://readdy.ai/api/search-image?query=group%20of%20cute%20fluffy%20animals%20gathered%20around%20a%20warm%20campfire%20in%20a%20cozy%20cabin%2C%20white%20bear%20panda%20and%20kittens%2C%20chibi%20anime%20style%2C%20warm%20orange%20firelight%2C%20adorable%20heartwarming%20mood&width=900&height=620&seq=col-pet&orientation=landscape",
  },
];

export const stats = [
  { value: "120+", label: "精选番剧" },
  { value: "40+", label: "主题片单" },
  { value: "9.3", label: "平均评分" },
  { value: "5000+", label: "追番小伙伴" },
];

export const faqs = [
  {
    q: "小狗看番的片单靠谱吗？",
    a: "每一部推荐都经过编辑逐集筛选，重点标注了看点、集数和适合的场景（比如深夜、吃饭、睡前）。推荐的番剧评分以真实口碑为准，拒绝硬吹水剧，让你直接照着片单追更不踩雷。",
  },
  {
    q: "推荐的都是治愈系番剧吗？",
    a: "不止。我们以治愈系为主，同时覆盖日常系、温馨番剧和萌系动画四大栏目。每一类都有独立的片单合集，你可以按当下的心情选择是想要大哭一场、笑到停不下来，还是安静地看完一集。",
  },
  {
    q: "为什么有些番剧标注了「催泪」也算治愈？",
    a: "治愈不只有轻松一种形态。很多经典作品通过细腻的情感释放，让人在哭过之后获得长久的温暖与释然。我们会在片单里明确标注情感类型，你可以放心按需选择。",
  },
  {
    q: "在哪里可以看这些番剧？",
    a: "片单只负责帮你挑出值得看的好番，播放请前往各大正版平台搜索番名即可。我们会随作品标注当前状态（已完结或连载中），方便你判断是否适合一口气看完。",
  },
  {
    q: "会持续更新新的片单吗？",
    a: "会的。我们会根据每季度新番和用户反馈持续扩充片单，也会定期整理「最被低估的冷门治愈番」这类主题合集。如果你有想看的类型，欢迎告诉我们。",
  },
];